import { Injectable } from '@angular/core';
import { jwtDecode } from 'jwt-decode';

/**
 * Local replacement for the former dlv-ng-auth UserService.
 * Reads the OIDC id_token (set by @delhivery/auth) from sessionStorage
 * and exposes the user claims plus an avatar background color helper.
 */
@Injectable({ providedIn: 'root' })
export class UserService {
  private readonly avatarColors = [
    '#F44336', '#E91E63', '#9C27B0', '#673AB7', '#3F51B5',
    '#2196F3', '#009688', '#4CAF50', '#FF9800', '#795548'
  ];

  getUserFromJwt(): Record<string, any> {
    const token = sessionStorage.getItem('id_token') || sessionStorage.getItem('access_token');
    if (!token) {
      return {};
    }
    try {
      const decoded = jwtDecode<Record<string, any>>(token);
      return {
        ...decoded,
        first_name: decoded['first_name'] || decoded['given_name'] || '',
        last_name: decoded['last_name'] || decoded['family_name'] || '',
        username: decoded['preferred_username'] || decoded['username'] || ''
      };
    } catch {
      return {};
    }
  }

  getBackgroundColor(name: string): string {
    if (!name) {
      return this.avatarColors[0];
    }
    let hash = 0;
    for (let i = 0; i < name.length; i++) {
      hash = name.charCodeAt(i) + ((hash << 5) - hash);
    }
    return this.avatarColors[Math.abs(hash) % this.avatarColors.length];
  }
}
